"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      detailInfo: {},
      handerOptions: [],
      checkboxGroup: [],
      pram: {
        auditStatus: 1
      }
    };
  },
  mounted: function mounted() {
    this.checkboxGroup = [];
  },
  methods: {
    initOpen: function initOpen() {
      var detailInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.detailInfo = detailInfo;
      this.visible = true;
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var _ref = _this.pram || {},
          description = _ref.description,
          auditStatus = _ref.auditStatus;
        aftersaleApi.auditFinancePending({
          aftersaleId: _this.detailInfo.id,
          description: description,
          auditStatus: auditStatus
        }).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};